// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container__EJWGP {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-family: Poppins;
}

.login_leftSide__GTm5J {
    display: flex;
    flex-direction: column;
    justify-content: start;
    width: 50%;
    height: 100%;
    background-color: #192949;
    z-index: 10;
    position: absolute;
    left: 0;
}

.login_trackContainer__1f6NM {
    height: 50%;
    display: flex;
}

.login_rightContainer__7Gjt6 {
    z-index: 20;
    width: 55%;
    height: 100%;
    background-color: #FFFFFF;
    position: absolute;
    right: 0;
}

.login_projectName__jc8ar {
    position: absolute;
    left: -160px;
    width: 160px;
    height: 110px;
    top: 30%;
}

.login_projectNameCircle__BNe9q {
    height: 110px;
    width: 110px;
    border-radius: 50%;
    background-color: #FFFFFF;
    position: absolute;
    left: -55px;
}

.login_projectNameText__KBfVX {
    display: flex;
    align-items: center;
    height: 100%;
    background-color: #FFFFFF;
    font-size: 36px;
    font-weight: bolder;
    z-index: 40;
    position: absolute;
    width: 200px;
    text-align: left;
}

.login_loginContainer__jUpuC {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.login_subtractBar__8ywgk {
    background-color: #FFFFFF;
    left: calc(100% - 36px);
    width: 36px;
    height: 150px;
    position: absolute;
    z-index: 90;
    top: -20px;
}

.login_upperCircle__Z4U4d {
    background-color: #F32735;
    border-bottom-right-radius: 50%;
    border-top-right-radius: 50%;
    height: 36px;
    width: 36px;
    position: absolute;
    z-index: 100;
    left: calc(100% - 36px);
    top: calc(0% - 36px);
}

.login_lowerCircle__kVhpB {
    background-color: #192949;
    border-bottom-right-radius: 50%;
    border-top-right-radius: 50%;
    height: 36px;
    width: 36px;
    position: absolute;
    z-index: 100;
    left: calc(100% - 36px);
    top: 100%;
}

.login_loginButton__LNkXg {
    background-color: #192949;
    color: #FFFFFF;
    font-size: 13px;
    padding: 18px 75px;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 15%) 0 11px 11px 0;
    margin-bottom: 20px;
    cursor: pointer;
}

.login_forgotPassword__jIrIN {
    font-size: 12px;
    color: #F32735;
    text-decoration: underline;
    cursor: pointer;
}

.login_inputField__CDQEi {
    width: 370px;
    margin-bottom: 2rem;
}

.login_inputField__CDQEi input {
    width: 100%;
    background-color: #F4F4F4;
    border: #E6E6E6 1px solid;
    height: 43px;
    font-size: 0.8rem;
    padding-left: 0.8rem;
}

.login_inputField__CDQEi input:focus {
    width: 100%;
    background-color: #F4F4F4;
    border: #E6E6E6 1px solid;
    height: 43px;
    outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/screens/login/login.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;AAC5B","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-family: Poppins;\n}\n\n.leftSide {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    width: 50%;\n    height: 100%;\n    background-color: #192949;\n    z-index: 10;\n    position: absolute;\n    left: 0;\n}\n\n.trackContainer {\n    height: 50%;\n    display: flex;\n}\n\n.rightContainer {\n    z-index: 20;\n    width: 55%;\n    height: 100%;\n    background-color: #FFFFFF;\n    position: absolute;\n    right: 0;\n}\n\n.projectName {\n    position: absolute;\n    left: -160px;\n    width: 160px;\n    height: 110px;\n    top: 30%;\n}\n\n.projectNameCircle {\n    height: 110px;\n    width: 110px;\n    border-radius: 50%;\n    background-color: #FFFFFF;\n    position: absolute;\n    left: -55px;\n}\n\n.projectNameText {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    background-color: #FFFFFF;\n    font-size: 36px;\n    font-weight: bolder;\n    z-index: 40;\n    position: absolute;\n    width: 200px;\n    text-align: left;\n}\n\n.loginContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n}\n\n.subtractBar {\n    background-color: #FFFFFF;\n    left: calc(100% - 36px);\n    width: 36px;\n    height: 150px;\n    position: absolute;\n    z-index: 90;\n    top: -20px;\n}\n\n.upperCircle {\n    background-color: #F32735;\n    border-bottom-right-radius: 50%;\n    border-top-right-radius: 50%;\n    height: 36px;\n    width: 36px;\n    position: absolute;\n    z-index: 100;\n    left: calc(100% - 36px);\n    top: calc(0% - 36px);\n}\n\n.lowerCircle {\n    background-color: #192949;\n    border-bottom-right-radius: 50%;\n    border-top-right-radius: 50%;\n    height: 36px;\n    width: 36px;\n    position: absolute;\n    z-index: 100;\n    left: calc(100% - 36px);\n    top: 100%;\n}\n\n.loginButton {\n    background-color: #192949;\n    color: #FFFFFF;\n    font-size: 13px;\n    padding: 18px 75px;\n    border-radius: 8px;\n    box-shadow: rgba(0, 0, 0, 15%) 0 11px 11px 0;\n    margin-bottom: 20px;\n    cursor: pointer;\n}\n\n.forgotPassword {\n    font-size: 12px;\n    color: #F32735;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.inputField {\n    width: 370px;\n    margin-bottom: 2rem;\n}\n\n.inputField input {\n    width: 100%;\n    background-color: #F4F4F4;\n    border: #E6E6E6 1px solid;\n    height: 43px;\n    font-size: 0.8rem;\n    padding-left: 0.8rem;\n}\n\n.inputField input:focus {\n    width: 100%;\n    background-color: #F4F4F4;\n    border: #E6E6E6 1px solid;\n    height: 43px;\n    outline: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `login_container__EJWGP`,
	"leftSide": `login_leftSide__GTm5J`,
	"trackContainer": `login_trackContainer__1f6NM`,
	"rightContainer": `login_rightContainer__7Gjt6`,
	"projectName": `login_projectName__jc8ar`,
	"projectNameCircle": `login_projectNameCircle__BNe9q`,
	"projectNameText": `login_projectNameText__KBfVX`,
	"loginContainer": `login_loginContainer__jUpuC`,
	"subtractBar": `login_subtractBar__8ywgk`,
	"upperCircle": `login_upperCircle__Z4U4d`,
	"lowerCircle": `login_lowerCircle__kVhpB`,
	"loginButton": `login_loginButton__LNkXg`,
	"forgotPassword": `login_forgotPassword__jIrIN`,
	"inputField": `login_inputField__CDQEi`
};
export default ___CSS_LOADER_EXPORT___;
